import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { searchFieldSchedulingUsers } from "requests/employee";
import { MGrid, MSpinner, MSplitter } from "components/Shared";
import SchedulingAssistantProfile from "./SchedulingAssistantProfile";
import { EmployeeListDto } from "interfaces/Mueller.Business.Models";
import { getSearchParameter } from "components/Shared/Functions";
import { RouteProps } from "react-router";
import { getPayPeriodList } from "actions/casetimelog";

interface Props {
  fetchingSchedulingUsers: boolean,
  schedulingUsers: EmployeeListDto[],
  getSchedulingUsers: (searchTerm: string) => void,
  payPeriods: Array<any>;
  getPayPeriodList: Function;
  // From router
  location: RouteProps["location"],
}

const SchedulingUserList = (props: Props) => {
  const [selectedUserIndex, setSelectedUserIndex] = useState<number>();
  const mounted = useRef(true);

  useEffect(() => {
    const searchTerm = getSearchParameter(props.location) ?? "";
    props.getSchedulingUsers(searchTerm);
    props.getPayPeriodList();
    return () => { mounted.current = false; };
  }, []);

  const onUserSelected = (i: number) => setSelectedUserIndex(i);
  const onCloseProfile = () => setSelectedUserIndex(undefined);

  const columns = [
    { name: "Employee Id", dataSource: "employeeId", width: 100 },
    { name: "First Name", dataSource: "firstName", width: 140 },
    { name: "Last Name", dataSource: "lastName", width: 140 },
    { name: "Role", dataSource: "role.name", width: 200 },
  ].map(c => ({ ...c, key: c.name }));

  if (!props.payPeriods) return <MSpinner />;

  return (
    <MSplitter
      firstChild={
        <div className="padding-page-content full-height">
          <MGrid
            configurationId="SchedulingUserList"
            headerText="Field Scheduling Users"
            columnDefinitions={columns}
            data={props.schedulingUsers}
            isFetchingData={props.fetchingSchedulingUsers}
            onRowClick={onUserSelected}
            displayNumOfItemsFound
            rowLastClicked={selectedUserIndex}
          />
        </div>
      }
      secondChild={selectedUserIndex >= 0 
        && <SchedulingAssistantProfile verticalDisplay selectedUserIndex={selectedUserIndex} />}
      secondChildTitle={selectedUserIndex >= 0 
        ? { title: "Scheduling Assistant", buttons: [{ icon: "close", onClick: onCloseProfile }] }
        : undefined}
    />
  );
};

const mapStateToProps = state => ({
  fetchingSchedulingUsers: state.employee.fetchingSchedulingUsers,
  schedulingUsers: state.employee.schedulingUsers,
  payPeriods: state.caseTimeLog.payPeriods,
});

const mapDispatchToProps = dispatch => ({
  getSchedulingUsers(searchTerm: string) {
    dispatch(searchFieldSchedulingUsers(searchTerm));
  },
  getPayPeriodList() {
    dispatch(getPayPeriodList());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SchedulingUserList);
